module.exports = __webpack_public_path__ + "static/img/cdm.6ff30046.svg";